import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Site } from '@services/api'
import { sitesApi } from '@services/api'

type SiteStore = {
  sites: Site[]
  activeSiteId: string | null
  isLoading: boolean
  fetchSites: () => Promise<void>
  setActiveSiteId: (id: string) => void
}

export const useSiteStore = create<SiteStore>()(
  persist(
    (set, get) => ({
      sites: [],
      activeSiteId: null,
      isLoading: false,

      fetchSites: async () => {
        set({ isLoading: true })
        try {
          const sites = await sitesApi.getAll()
          const { activeSiteId } = get()
          // Keep existing active site if still valid, otherwise default to first
          const validId = sites.find((s) => s.id === activeSiteId)
            ? activeSiteId
            : (sites[0]?.id ?? null)
          set({ sites, activeSiteId: validId, isLoading: false })
        } catch {
          set({ isLoading: false })
        }
      },

      setActiveSiteId: (id) => set({ activeSiteId: id }),
    }),
    {
      name: 'seo-booster-site',
      // Only persist the active selection — site list is always fetched fresh
      partialize: (s) => ({ activeSiteId: s.activeSiteId }),
    }
  )
)
